import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http'; // Import provideHttpClient
import { routes } from './app.routes';
import { provideToastr } from 'ngx-toastr';
import { authInterceptor } from './auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    // provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 5000,
      preventDuplicates: true,
      enableHtml: true,
      toastClass: 'ngx-toastr custom-toastr', 
      progressBar: true, 
      progressAnimation: 'decreasing',
      tapToDismiss: true,
      newestOnTop: true,
      easeTime: 300,
    }),
  ],
};
